module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legal"
  }, [_c('navbar'), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Adatkezelési nyilatkozat")])]), _vm._v(" "), _c('md-card-content', [_vm._v("\n\t\t\t\t\tAz alkalmazás jelenleg pilot változatban elérhető, és kipróbálható. A folyamatban lévő fejlesztések és véglegesítések miatt a változások jogát fenntartjuk. Hamarosan frissítjük az adatvédelmi irányelveinket, erről mindenkinek értesítés fogunk küldeni. A pilot fázisban kizárólag saját felelősségére ossza meg az adatok a programban. Az egészségügyi adatokat kizárólag a beteg által kiválasztott orvossal osztjuk meg a rendszerünkön keresztül. Az adatokat kutatási célú felhasználásra csak a felhasználó előzetes beleegyezésével tesszük elérhetővé, amit a program felületén engedélyezhet.\n\t\t\t\t")])], 1), _vm._v(" "), _c('br'), _c('br')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c70c4ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LegalView.vue
// module id = 421
// module chunks = 2